module.exports = __webpack_public_path__ + "static/media/sons.3482b5a5.svg";